export const tripEnumObject = {
  oneWay: '1',
  rental: '3',
  airport: '4',
  outStationRound:'9',
  outStation:'8',
}
export const enumValue = {
  zero:'0'
}
export const toastObject = {
  infoAutoClose: 5000,
  countryCode:'+91'
}
export const fileSizeObject = {
  fileSize: 1048576,
  // 1MB = 1024 * 1024 = 1048576
};
